import { render, staticRenderFns } from "./renew-record-order.vue?vue&type=template&id=2a204001&scoped=true"
import script from "./renew-record-order.vue?vue&type=script&lang=ts"
export * from "./renew-record-order.vue?vue&type=script&lang=ts"
import style0 from "./renew-record-order.vue?vue&type=style&index=0&id=2a204001&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a204001",
  null
  
)

export default component.exports